import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "../lib/api";
import NewsCard from "../components/NewsCard";

export default function NewsList() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const url = q ? `/news?q=${encodeURIComponent(q)}` : "/news?limit=50";
        const { data } = await api.get(url);
        setItems(data);
      } finally { setLoading(false); }
    })();
  }, [q]);

  return (
    <div className="pt-28 pb-20 max-w-[1400px] mx-auto px-6 md:px-10">
      <h1 className="font-display font-bold text-5xl md:text-6xl text-white tracking-tighter mb-2">
        {q ? <>Results for <span className="text-yellow-400">"{q}"</span></> : "Latest News"}
      </h1>
      <p className="text-zinc-400 mb-10">All editorial coverage from HashRate.</p>
      {loading ? (
        <div className="text-zinc-500">Loading...</div>
      ) : items.length === 0 ? (
        <div className="text-zinc-500">No articles found.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="news-grid">
          {items.map((a) => <NewsCard key={a.id} article={a} />)}
        </div>
      )}
    </div>
  );
}
